// Chakra imports
import {
  Avatar,
  AvatarGroup,
  Box,
  Button,
  Flex,
  Grid,
  Icon,
  Image,
  Link,
  Switch,
  Text,
  useColorMode,
  useColorModeValue,
} from "@chakra-ui/react";
// Assets
import avatar2 from "assets/img/avatars/avatar2.png";
import avatar3 from "assets/img/avatars/avatar3.png";
import avatar4 from "assets/img/avatars/avatar4.png";
import avatar5 from "assets/img/avatars/avatar5.png";
import avatar6 from "assets/img/avatars/avatar6.png";
import ImageArchitect1 from "assets/img/ImageArchitect1.png";
import ImageArchitect2 from "assets/img/ImageArchitect2.png";
import ImageArchitect3 from "assets/img/ImageArchitect3.png";
import gana from "../../img/gana.png";
// Custom components
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import BarChart from "components/Charts/BarChart";
import {
  barChartData,
  barChartOptions,
  lineChartData,
  lineChartOptions,
} from "variables/charts";
import { getBarChart } from "variables/trafico";

import React, { useEffect, useState } from "react";
import {
  FaCube,
  FaFacebook,
  FaInstagram,
  FaPenFancy,
  FaPlus,
  FaTwitter,
  FaUserCircle,
  FaCamera,
  FaEdit,
} from "react-icons/fa";
import {
  UserOutlined,
  MailOutlined,
  ScheduleOutlined,
  EnvironmentOutlined,
  BankOutlined,
  FileTextOutlined,
  PhoneOutlined,
} from "@ant-design/icons";
import { IoDocumentsSharp } from "react-icons/io5";

import { Input } from "antd";
import { Modal, Segmented } from "antd";
import { message } from "antd";
import paypallogo from "../../img/paypal.png";

function Profile() {
  const { colorMode } = useColorMode();

  const [open, setOpen] = useState(false);

  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState("Content of the modal");

  const [nombres, setNombres] = useState("");
  const [email, setEmail] = useState("");
  const [telefono, setTelefono] = useState("");
  const [foto, setFoto] = useState("perfil/silueta.jpg");

  const [selectedImage2, setSelectedImage2] = useState(null);
  const [file2, setFile2] = useState(null);
  const [nuevafoto, setNuevafoto] = useState(null);
  const [cargandofoto, setCargandofoto] = useState(false);

  const [ultimos, setUltimos] = useState([]);

  const [totaltraffic, setTotaltraffic] = useState({
    facebook: 0,
    porcentajef: 0,
    instagram: 0,
    porcentajei: 0,
    whatsapp: 0,
    porcentajew: 0,
    directlink: 0,
    porcentajel: 0,
    total: 0,
  });

  const [messageApi, contextHolder] = message.useMessage();

  // Chakra color mode
  const textColor = useColorModeValue("gray.700", "white");
  const iconColor = useColorModeValue("blue.500", "white");
  const bgProfile = useColorModeValue("hsla(0,0%,100%,.8)", "navy.800");
  const borderProfileColor = useColorModeValue("white", "transparent");
  const emailColor = useColorModeValue("gray.400", "gray.300");

  const showModal = () => {
    setOpen(true);
  };

  const success = () => {
    messageApi.open({
      type: "success",
      content: "Account successfully saved",
    });
  };

  const error_empty = () => {
    messageApi.open({
      type: "error",
      content: "Complete the form",
    });
  };

  const error_email_invalid = () => {
    messageApi.open({
      type: "error",
      content: "Enter a valid Email",
    });
  };

  function formatearFecha(fechaString) {
    const opciones = { day: "2-digit", month: "short", year: "numeric" };

    const fecha = new Date(fechaString);

    if (isNaN(fecha.getTime())) {
      console.error("Valor de fecha inválido:", fecha);
      return "Fecha inválida";
    }

    return new Intl.DateTimeFormat("es-ES", opciones).format(fecha);
  }

  const handleOk = () => {
    setModalText("The modal will be closed after two seconds");
    setConfirmLoading(true);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    let type_error = "";
    let emailt = document.getElementById("email-edit").value;
    let namet = document.getElementById("fullname-edit").value;
    let telefonot = document.getElementById("mobile-edit").value;

    if (emailt == "") {
      type_error = "vacio";
    } else if (!emailRegex.test(emailt)) {
      type_error = "email";
    }

    if (namet == "") {
      type_error = "vacio";
    }

    if (telefonot == "") {
      type_error = "vacio";
    }

    if (type_error === "vacio") {
      error_empty();
      setConfirmLoading(false);
      return;
    }

    if (type_error === "email") {
      console.log(type_error);
      error_email_invalid();
      setConfirmLoading(false);
      return;
    }

    const data = {
      token: localStorage.getItem("token_royal"),
      nombres: namet,
      email: emailt,
      telefono: telefonot,
    };

    fetch(`${process.env.REACT_APP_API}/updateprofilewill`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.message) {
          if (result.message == "modificado") {
            setConfirmLoading(false);
            setOpen(false);
            obtenerdatos();
            success();
          }
        } else {
          console.log(result.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleFileChange2 = (event) => {
    setFile2(event.target.files[0]);

    const file = event.target.files[0];

    if (file.type !== "image/png" && file.type !== "image/jpeg") {
      messageApi.open({
        type: "error",
        content: "Seleccione un archivo de imagen PNG o JPEG.",
      });
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      messageApi.open({
        type: "error",
        content: "El Tamaño del Archivo no debe superar 5 MB",
      });
      return;
    }

    if (file) {
      const imageUrl = URL.createObjectURL(file);

      setSelectedImage2(imageUrl);
    }
  };

  const enviarphoto = () => {
    const formData = new FormData();
    formData.append("file", file2);
    fetch(`${process.env.REACT_APP_API}/uploadphoto`, {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Error en la carga del archivo");
        }
        return response.text();
      })
      .then((data) => {
        const valor = JSON.parse(data);
        console.log(valor);
        setNuevafoto(valor.file);
        setCargandofoto(true);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const obtenertotales = () => {
    const data = {
      token: localStorage.getItem("token_royal"),
    };
    fetch(`${process.env.REACT_APP_API}/totalvisitaswill`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.message) {
          console.log(result.message);
        } else {
          setTotaltraffic(result);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const obtenercinco = () => {
    const data = {
      token: localStorage.getItem("token_royal"),
    };
    fetch(`${process.env.REACT_APP_API}/ultimoscinco`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result) {
          console.log(result);
          setUltimos(result);
        } else {
          console.log(result.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const activarfile2 = () => {
    document.getElementById("fileInput2").click();
  };

  const handleCancel = () => {
    console.log("Clicked cancel button");
    setOpen(false);
  };

  const obtenerdatos = () => {
    const data = {
      token: localStorage.getItem("token_royal"),
    };
    fetch(`${process.env.REACT_APP_API}/verdatoswill`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result) {
          if (result.telefono) {
            setTelefono(result.telefono);
          }
          if (result.foto) {
            setFoto(result.foto);
          }
          if (result.nombres) {
            setNombres(result.nombres);
          }
          if (result.email) {
            setEmail(result.email);
          }
          if (result.message == "Access Denied") {
            window.location.href = "/#/auth/signin";
            window.location.reload();
          }
          console.log(result);
        } else {
          console.log(result.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const updatefotonueva = () => {
    const data = {
      token: localStorage.getItem("token_royal"),
      nuevafoto: nuevafoto,
    };
    fetch(`${process.env.REACT_APP_API}/updatefotonueva`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result) {
          messageApi.open({
            type: "success",
            content: "Photo successfully saved",
          });
        } else {
          console.log(result.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const obtenertoken = () => {
    const isAuthenticated = localStorage.getItem("token_royal");

    console.log(window.location.hash);
    if (!isAuthenticated) {
      window.location.href = "/#/auth/signin";
      window.location.reload();
    }
  };

  useEffect(() => {
    obtenertoken();
    obtenerdatos();
    obtenercinco();
    obtenertotales();
  }, []);

  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    getBarChart().then(setChartData);
  }, []);

  useEffect(() => {
    console.log(chartData);
  }, [chartData]);

  useEffect(() => {
    const fotoactual = process.env.REACT_APP_API + "/" + foto;

    if (fotoactual != process.env.REACT_APP_API + "/undefined") {
      if (selectedImage2 != fotoactual) {
        setCargandofoto(true);
        enviarphoto();
      }
    }

    //console.log(fotoactual)
    //console.log(selectedImage2)
  }, [file2]);

  useEffect(() => {
    if (nuevafoto == null) {
    } else {
      updatefotonueva();
    }
  }, [nuevafoto]);

  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px", lg: "100px" }}>
      <Flex
        direction={{ sm: "column", md: "row" }}
        mb="24px"
        maxH="330px"
        justifyContent={{ sm: "center", md: "space-between" }}
        align="center"
        backdropFilter="blur(21px)"
        boxShadow="0px 2px 5.5px rgba(0, 0, 0, 0.02)"
        border="1.5px solid"
        borderColor={borderProfileColor}
        bg={bgProfile}
        p="24px"
        borderRadius="20px"
      >
        <Flex
          align="center"
          mb={{ sm: "10px", md: "0px" }}
          direction={{ sm: "column", md: "row" }}
          w={{ sm: "100%" }}
          textAlign={{ sm: "center", md: "start" }}
        >
          <Avatar
            me={{ md: "22px" }}
            src={selectedImage2 || `${process.env.REACT_APP_API}/${foto}`}
            w="80px"
            h="80px"
            borderRadius="15px"
          />
          <Flex direction="column" maxWidth="100%" my={{ sm: "14px" }}>
            <Text
              fontSize={{ sm: "lg", lg: "xl" }}
              color={textColor}
              fontWeight="bold"
              ms={{ sm: "8px", md: "0px" }}
            >
              {nombres}
            </Text>
            <Text
              fontSize={{ sm: "sm", md: "md" }}
              color={emailColor}
              fontWeight="semibold"
            >
              {email}
            </Text>
          </Flex>
        </Flex>
        <Flex
          direction={{ sm: "column", lg: "row" }}
          w={{ sm: "100%", md: "50%", lg: "auto" }}
        >
          <input
            type="file"
            onChange={handleFileChange2}
            accept=".jpg, .jpeg"
            style={{ display: "none" }}
            id="fileInput2"
          />
          {cargandofoto == true ? (
            <Button
              onClick={() => {
                activarfile2();
              }}
              p="0px"
              bg="transparent"
              variant="no-effects"
            >
              <Flex
                align="center"
                w={{ sm: "100%", lg: "135px" }}
                bg={"#003366"}
                borderRadius="8px"
                justifyContent="center"
                py="10px"
                boxShadow="0px 2px 5.5px rgba(0, 0, 0, 0.06)"
                cursor="pointer"
              >
                <Icon color={"white"} as={FaCamera} me="6px" />
                <Text fontSize="xs" color={"white"} fontWeight="bold">
                  EDIT PHOTO
                </Text>
              </Flex>
            </Button>
          ) : (
            <Button p="0px" bg="transparent" variant="no-effects">
              <Flex
                align="center"
                w={{ sm: "100%", lg: "135px" }}
                bg={"#003366"}
                borderRadius="8px"
                justifyContent="center"
                py="10px"
                boxShadow="0px 2px 5.5px rgba(0, 0, 0, 0.06)"
                cursor="pointer"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 50 50"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#415A77"
                >
                  <circle
                    cx="25"
                    cy="25"
                    r="20"
                    stroke="#ccc"
                    stroke-width="5"
                    fill="none"
                  />
                  <circle
                    cx="25"
                    cy="25"
                    r="20"
                    stroke="#415A77"
                    stroke-width="5"
                    fill="none"
                    stroke-linecap="round"
                    stroke-dasharray="90"
                    stroke-dashoffset="60"
                  >
                    <animateTransform
                      attributeName="transform"
                      type="rotate"
                      from="0 25 25"
                      to="360 25 25"
                      dur="1s"
                      repeatCount="indefinite"
                    />
                  </circle>
                </svg>
                <Text fontSize="xs" color={"white"} fontWeight="bold">
                  SUBIENDO FOTO
                </Text>
              </Flex>
            </Button>
          )}

          {/* <Button p="0px" bg="transparent" variant="no-effects">
            <Flex
              align="center"
              w={{ lg: "135px" }}
              bg={colorMode === "dark" ? "navy.900" : "#fff"}
              borderRadius="8px"
              justifyContent="center"
              py="10px"
              mx={{ lg: "1rem" }}
              cursor="pointer"
            >
              <Icon color={textColor} as={IoDocumentsSharp} me="6px" />
              <Text fontSize="xs" color={textColor} fontWeight="bold">
                TEAMS
              </Text>
            </Flex>
          </Button> */}
          {/* <Button p="0px" bg="transparent" variant="no-effects">
            <Flex
              align="center"
              w={{ lg: "135px" }}
              borderRadius="15px"
              justifyContent="center"
              py="10px"
              cursor="pointer"
            >
              <Icon color={textColor} as={FaPenFancy} me="6px" />
              <Text fontSize="xs" color={textColor} fontWeight="bold">
                PROJECTS
              </Text>
            </Flex>
          </Button> */}
        </Flex>
      </Flex>

      <Grid templateColumns={{ sm: "1fr", xl: "repeat(3, 1fr)" }} gap="22px">
        {/* <Card p="16px">
          <CardHeader p="12px 5px" mb="12px">
            <Text fontSize="lg" color={textColor} fontWeight="bold">
              Platform Settings
            </Text>
          </CardHeader>
          <CardBody px="5px">
            <Flex direction="column">
              <Text fontSize="sm" color="gray.400" fontWeight="600" mb="20px">
                ACCOUNT
              </Text>
              <Flex align="center" mb="20px">
                <Switch colorScheme="blue" me="10px" />
                <Text
                  noOfLines={1}
                  fontSize="md"
                  color="gray.400"
                  fontWeight="400"
                >
                  Email me when someone follows me
                </Text>
              </Flex>
              <Flex align="center" mb="20px">
                <Switch colorScheme="blue" me="10px" />
                <Text
                  noOfLines={1}
                  fontSize="md"
                  color="gray.400"
                  fontWeight="400"
                >
                  Email me when someone answers on my post
                </Text>
              </Flex>
              <Flex align="center" mb="20px">
                <Switch colorScheme="blue" me="10px" />
                <Text
                  noOfLines={1}
                  fontSize="md"
                  color="gray.400"
                  fontWeight="400"
                >
                  Email me when someone mentions me
                </Text>
              </Flex>
              <Text
                fontSize="sm"
                color="gray.400"
                fontWeight="600"
                m="6px 0px 20px 0px"
              >
                APPLICATION
              </Text>
              <Flex align="center" mb="20px">
                <Switch colorScheme="blue" me="10px" />
                <Text
                  noOfLines={1}
                  fontSize="md"
                  color="gray.400"
                  fontWeight="400"
                >
                  New launches and projects
                </Text>
              </Flex>
              <Flex align="center" mb="20px">
                <Switch colorScheme="blue" me="10px" />
                <Text
                  noOfLines={1}
                  fontSize="md"
                  color="gray.400"
                  fontWeight="400"
                >
                  Monthly product changes
                </Text>
              </Flex>
              <Flex align="center" mb="20px">
                <Switch colorScheme="blue" me="10px" />
                <Text
                  noOfLines={1}
                  fontSize="md"
                  color="gray.400"
                  fontWeight="400"
                >
                  Subscribe to newsletter
                </Text>
              </Flex>
            </Flex>
          </CardBody>
        </Card> */}
        <Card p="16px" my={{ sm: "24px", xl: "0px" }}>
          <Flex p="12px 5px" mb="12px" justify="space-between">
            <Text fontSize="lg" color={textColor} fontWeight="bold">
              Profile Information
            </Text>
            {contextHolder}
            <Button
              onClick={() => {
                showModal();
              }}
              p="0px"
              bg="transparent"
              variant="no-effects"
            >
              <Flex
                align="center"
                w={{ sm: "100%", lg: "135px" }}
                bg={"#003366"}
                color={"white"}
                borderRadius="8px"
                justifyContent="center"
                py="10px"
                px="5px"
                boxShadow="0px 2px 5.5px rgba(0, 0, 0, 0.06)"
                cursor="pointer"
              >
                <Icon color={"white"} as={FaEdit} me="6px" />
                <Text fontSize="xs" color={"white"} fontWeight="bold">
                  EDIT INFO
                </Text>
              </Flex>
            </Button>

            <Modal
              title=""
              open={open}
              onOk={handleOk}
              confirmLoading={confirmLoading}
              onCancel={handleCancel}
              okText="Edit Information"
            >
              <div>
                <div
                  style={{
                    padding: "20px",
                    fontSize: "16px",
                    backgroundColor: "#003366",
                    color: "#fff",
                    borderTopLeftRadius: "10px",
                    borderTopRightRadius: "10px",
                  }}
                  align="center"
                >
                  <strong>Profile Information</strong>
                </div>
                <br />
                <span style={{ fontSize: "14px", marginTop: "10px" }}>
                  Full Name:
                </span>
                <Input
                  size="large"
                  id="fullname-edit"
                  placeholder=""
                  defaultValue={nombres}
                  prefix={<UserOutlined />}
                />

                <span style={{ fontSize: "14px", marginTop: "10px" }}>
                  Mobile:
                </span>
                <Input
                  size="large"
                  id="mobile-edit"
                  placeholder=""
                  defaultValue={telefono}
                  prefix={<PhoneOutlined />}
                />

                <span style={{ fontSize: "14px", marginTop: "10px" }}>
                  Email:
                </span>
                <Input
                  size="large"
                  id="email-edit"
                  placeholder="Email"
                  defaultValue={email}
                  disabled
                  prefix={<MailOutlined />}
                />
              </div>
            </Modal>
          </Flex>
          <CardBody px="5px">
            <Flex direction="column">
              <Text fontSize="md" color="gray.400" fontWeight="400" mb="30px">
                Describe Tu situación.
              </Text>
              <Flex align="center" mb="18px">
                <Text
                  fontSize="md"
                  color={textColor}
                  fontWeight="bold"
                  me="10px"
                >
                  Full Name:{" "}
                </Text>
                <Text fontSize="md" color="gray.400" fontWeight="400">
                  {nombres}
                </Text>
              </Flex>
              <Flex align="center" mb="18px">
                <Text
                  fontSize="md"
                  color={textColor}
                  fontWeight="bold"
                  me="10px"
                >
                  Mobile:{" "}
                </Text>
                <Text fontSize="md" color="gray.400" fontWeight="400">
                  {telefono}
                </Text>
              </Flex>
              <Flex align="center" mb="18px">
                <Text
                  fontSize="md"
                  color={textColor}
                  fontWeight="bold"
                  me="10px"
                >
                  Email:{" "}
                </Text>
                <Text fontSize="md" color="gray.400" fontWeight="400">
                  {email}
                </Text>
              </Flex>
            </Flex>
          </CardBody>
        </Card>
        <Card p="16px">
          <CardHeader p="12px 5px" mb="12px">
            <Text fontSize="lg" color={textColor} fontWeight="bold">
              Last 5 Referrals
            </Text>
          </CardHeader>
          <CardBody px="5px">
            <Flex direction="column" w="100%">
              {ultimos.map((val, key) => {
                return (
                  <Flex justifyContent="space-between" mb="21px">
                    <Flex align="center">
                      <Avatar
                        src={`${process.env.REACT_APP_API}/${val.Foto}`}
                        w="50px"
                        h="50px"
                        borderRadius="15px"
                        me="10px"
                      />
                      <Flex direction="column">
                        <Text fontSize="sm" color={textColor} fontWeight="bold">
                          {val.Nombres}
                        </Text>
                        <Text fontSize="xs" color="gray.400" fontWeight="400">
                          {formatearFecha(val.Fecha)}
                        </Text>
                      </Flex>
                    </Flex>
                    <Button
                      p="0px"
                      bg="transparent"
                      variant="no-effects"
                    ></Button>
                  </Flex>
                );
              })}
            </Flex>
          </CardBody>
        </Card>
        <Card p="0px" maxW={{ sm: "100%", md: "100%" }}>
          <Flex direction="column" mb="40px" p="28px 0px 0px 22px">
            <Text color="gray.400" fontSize="sm" fontWeight="bold" mb="6px">
              SOCIAL TRAFFIC
            </Text>
            <Text color={textColor} fontSize="lg" fontWeight="bold">
              Total Visits
            </Text>
          </Flex>
          <Box minH="300px">
            {chartData == null ? (
              <></>
            ) : (
              <BarChart chartData={chartData} chartOptions={barChartOptions} />
            )}
          </Box>
        </Card>
      </Grid>
      <Card p="16px" my="24px">
        <CardHeader p="12px 5px" mb="12px">
          <Flex direction="column">
            <Text fontSize="lg" color={textColor} fontWeight="bold">
              News:
            </Text>
            <Text fontSize="sm" color="gray.400" fontWeight="400">
              Royal Insurance LLC
            </Text>
          </Flex>
        </CardHeader>
        <CardBody px="5px">
          <Grid
            templateColumns={{ sm: "1fr", md: "1fr 1fr", xl: "repeat(3, 1fr)" }}
            gap="24px"
          >
            <Flex direction="column">
              <Box mb="20px" position="relative" borderRadius="15px">
                <Image src={gana} borderRadius="15px" />
                <Box
                  w="100%"
                  h="100%"
                  position="absolute"
                  top="0"
                  borderRadius="15px"
                  // bg="linear-gradient(360deg, rgba(49, 56, 96, 0.16) 0%, rgba(21, 25, 40, 0.88) 100%)"
                ></Box>
              </Box>
              <Flex direction="column">
                <Text fontSize="md" color="gray.400" fontWeight="600" mb="10px">
                  Sistema de Recompenza
                </Text>
                <Text
                  fontSize="xl"
                  color={textColor}
                  fontWeight="bold"
                  mb="10px"
                >
                  GANA 30 USD Por Referido
                </Text>
                <Text fontSize="md" color="gray.400" fontWeight="400" mb="20px">
                  Estaras ganando con nuestro sistema de referido con solo
                  invitar a personas que deseen obtener un seguro de salud.
                </Text>
                <Flex justifyContent="space-between">
                  <Button variant="dark" minW="110px" h="36px">
                    VIEW ALL
                  </Button>
                  <AvatarGroup size="xs">
                    <Avatar name="Ryan Florence" src={avatar6} />
                    <Avatar name="Segun Adebayo" src={avatar2} />
                    <Avatar name="Kent Dodds" src={avatar3} />
                    <Avatar name="Prosper Otemuyiwa" src={avatar4} />
                  </AvatarGroup>
                </Flex>
              </Flex>
            </Flex>

            {/* <Button
              p="0px"
              bg="transparent"
              border="1px solid lightgray"
              borderRadius="15px"
              minHeight={{ sm: "200px", md: "100%" }}
            >
              <Flex direction="column" justifyContent="center" align="center">
                <Icon as={FaPlus} color={textColor} fontSize="lg" mb="12px" />
                <Text fontSize="lg" color={textColor} fontWeight="bold">
                  Create a New Project
                </Text>
              </Flex>
            </Button> */}
          </Grid>
        </CardBody>
      </Card>
    </Flex>
  );
}

export default Profile;
